<!--  -->
<template>
  <div class="page">
    <div class="content">
      <div class="label">
        <div class="input">
          <div>收件人<span>*</span></div>
          <input
            v-model="consignee"
            type="text"
            @keyup="consignee = consignee.slice(0, 20)"
            placeholder="请填写收件人姓名"
          />
        </div>
      </div>
      <div class="label">
        <div class="input">
          <div>手机号<span>*</span></div>
          <input
            v-model="phone"
            type="tel"
            @keyup="phone = phone.slice(0, 11)"
            placeholder="请填写收件人手机号"
          />
        </div>
      </div>
      <div class="label">
        <div class="input">
          <div>所在地区<span>*</span></div>
          <div class="area" :class="{ active: local }" @click="showArea = true">
            <p>{{ local || '请选择省市区' }}</p>
          </div>
          <div v-if="local" class="delete" @click="clear">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/delete.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="label">
        <div class="input">
          <div>详细地址<span>*</span></div>
          <textarea
            v-model="addressDetail"
            type="text"
            @keyup="addressDetail = addressDetail.slice(0, 200)"
            placeholder="请填写详细地址"
          />
        </div>
      </div>
    </div>
    <div class="submit" @click="submit"><div>提交</div></div>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :value="initValue"
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import wx from 'weixin-js-sdk';
import { reqBiliAddress, reqBiliAddressEdit } from '@/api/personal/index';

export default {
  components: {},
  data() {
    return {
      consignee: '',
      phone: '',
      local: '',
      province: '',
      city: '',
      area: '',
      addressDetail: '',
      showArea: false,
      areaList,
      iqhId: this.$route.query.iqhId,
      pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, // 正则验证手机号
      initValue: '',
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 省市区确认
    onConfirm(values) {
      this.province = values[0]?.name;
      this.city = values[1]?.name;
      this.area = values[2]?.name;
      this.local = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ');
      this.showArea = false;
    },
    async getAddress() {
      // eslint-disable-next-line camelcase
      const { county_list } = areaList;
      const { data } = await reqBiliAddress(this.iqhId);
      const { consignee, phone, province, city, area, addressDetail } = data;
      this.local =  area?`${province} ${city} ${area}`:"";
      const initValue = this.getKeyByValue(county_list, area);
      this.initValue = initValue;
      Object.assign(this, { consignee, phone, province, city, area, addressDetail });
    },
    async submit() {
      const { consignee, phone, province, local, city, area, addressDetail } = this;
      const arr = [consignee, phone, local, addressDetail];
      if (!consignee) {
        this.$toast('请填写收件人姓名');
        return;
      }
      if (!phone) {
        this.$toast('请填写收货手机号');
        return;
      }
      if (!local) {
        this.$toast('请填写所在地区');
        return;
      }
      if (!addressDetail) {
        this.$toast('请填写详细地址');
        return;
      }
      if (!this.pattern.test(this.phone)) {
        this.$toast('手机号格式错误，请输入正确的手机号');
        return;
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const { code, msg } = await reqBiliAddressEdit({
        addressDetail,
        area,
        city,
        consignee,
        id: this.iqhId,
        phone,
        province,
      });
      this.$toast(code === 0 ? '提交成功' : msg);
      if (code === 0) {
        wx.miniProgram.navigateBack();
      }
    },
    clear() {
      this.local = '';
      this.province = '';
      this.city = '';
      this.area = '';
    },
    getKeyByValue(obj, value) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in obj) {
        if (obj[key] === value) {
          return key;
        }
      }
      return null; // 如果没有找到匹配的键，则返回null
    },
  },
  created() {
    this.getAddress();
  },
  mounted() {
    document.title = '修改地址';
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100vh;
  padding: 36px;
  background: #f7f8fc;
  .content {
    width: 678px;
    padding: 36px 29px;
    background: #fff;
    border-radius: 14px;

    .label {
      padding-bottom: 22px;
      .input {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          color: #333;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
          span {
            position: relative;
            top: 4px;
            padding-left: 2px;
            color: #ff3938;
            font-size: 25px;
          }
        }
        .delete {
          position: absolute;
          right: 20px;
          z-index: 10;
          width: 50px;
          height: 50px;
          font-size: 30px;
          line-height: 50px;
          text-align: center;
          // background: rgba(0, 0, 0, 0.05);
          border-radius: 50%;
          img {
            width: 29px;
            height: 29px;
          }
        }
        textarea {
          height: 140px !important;
          padding-top: 20px;
          line-height: 34px;
        }
        .area {
          line-height: 87px;
          p {
            margin: 0;
            line-height: 87px;
          }
        }
        .area.active {
          p {
            width: 380px;
            overflow: hidden;
            color: #333;
            font-weight: 500;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .area,
        input,
        textarea {
          box-sizing: border-box;
          width: 475px;
          height: 87px;
          padding-left: 22px;
          color: #333;
          font-weight: 500;
          font-size: 25px;
          background: #f5f6f7;
          border: none;
          border-radius: 14px;
        }
        .area,
        input::placeholder,
        textarea::placeholder {
          color: #999;
          font-weight: 400;
        }
      }
      p {
        margin-top: 14px;
        color: #999;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }
    }
  }
  .submit {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    background: #fff;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
    div {
      width: 678px;
      height: 80px;
      margin: 22px auto 0;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
}
</style>
